module.exports = __webpack_public_path__ + "static/media/contact_t1.98c60277.png";